module.exports = __webpack_public_path__ + "img/floating-button-2.853473be.svg";